module.exports = __webpack_public_path__ + "static/media/carCoverBlack.e28053b7.png";